
<template>
    <div :class="['privilege-compare', +vipInfo.vipStatus ? 'vip' : '']">
        <div class="table-title">会员权益明细对比</div>
        <div :class="['compare-table']">
            <div
                v-for="(item, index1) in list"
                :key="index1"
                class="row"
            >
                <div
                    v-for="(subItem, index2) in item"
                    :key="index2"
                    :class="[
                        'column',
                        'column-' + index2,
                        fontList[index2].isSelect ? 'actived' : '',
                        index1 === 0 ? 'header' : '',
                        index1 === list.length - 1 ? 'last-line' : '',
                        index1 !== 0 && index2 === 0 ? 'fisrt-column' : '',
                        index2 === item.length - 1 ? 'last-column' : '',
                        index2 === 0 ? vipInfo.vipStatusName + '-fisrt-column-width' : '',
                        (+vipInfo.vipStatus && vipInfo.vipStatusName === 'beginnerVip')
                            ? (index2 === 0 ? 'young-vip-column-1' : '')
                            : (index2 === 0 ? 'not-young-vip-column-1' : ''),
                    ]"
                    :style="{
                        background: fontList[index2].isSelect ? '' : colorList[index1 % 2]
                            && colorList[index1 % 2][index2],
                        color: fontList[index2] && fontList[index2].color,
                        fontWeight: fontList[index2] && fontList[index2].fontWeight || 400,
                        borderColor: borderColor[index2],
                    }"
                >
                    <!-- 特殊容器样式-走定位模式 -->
                    <template
                        v-if="fontList[index2].isSelect"
                    >
                        <div
                            :class="[
                                'specail-box',
                                index1 === 0 ? 'first-box' : '',
                                index1 === list.length - 1 ? 'last-box' : '',
                            ]"
                            :style="{
                                background: colorList[index1 % 2] && colorList[index1 % 2][index2],
                                borderColor: borderColor[index2],
                            }"
                        >
                            <div v-if="subItem.value">{{ subItem.value }}</div>
                            <img
                                v-if="!subItem.value"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/account/false.png"
                                class="false"
                            />
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="subItem.value">{{ subItem.value }}</div>
                        <img
                            v-if="!subItem.value"
                            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/account/false.png"
                            class="false"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

/**
 * @desc 权益列表
 */

import {rightList, colorList, fontList} from '../table';
import {mapState} from 'vuex';

export default {
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo || {}
        })
    },
    watch: {
        vipInfo: {
            handler(val) {
                if (!val) {
                    return;
                }
                if (+val.vipStatus === 1) {
                    this.fontList[2].isSelect = true;
                }
                else {
                    this.fontList[3].isSelect = true;
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            list: rightList,
            colorList: colorList,
            fontList: fontList,
            borderColor: [
                'rgba(202, 220, 253, .8)',
                'rgba(202, 220, 253, .8)',
                '#FFE2CD',
                'rgba(202, 220, 253, .8)'
            ]
        };
    }
};
</script>
<style lang="less" scoped>
.privilege-compare {
    margin-top: 30px;
    padding: 23px 30px;

    .table-title {
        color: #333;
        font-family: PingFang SC;
        font-style: normal;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
    }

    .button {
        cursor: pointer;
        margin: 61px auto 0;
        padding: 12px 0;
        width: 326px;
        height: 48px;
        background-color: #05f;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        font-weight: 500;

        &:hover {
            opacity: .8;
        }
    }

    .compare-table {
        width: 100%;
        border-left: 1px solid rgba(202, 220, 253, .8);
        border-radius: 18px;
        margin-top: 30px;

        .row {
            display: flex;

            .column {
                flex: 1;
                position: relative;
                padding: 20px 33px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                // box-sizing: border-box;
                font-family: "PingFang SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
                border-bottom: 1px solid rgba(202, 220, 253, .8);

                &.header {
                    height: 65px;
                    color: #1e1f24;
                    font-family: "PingFang SC";
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600 !important;
                    line-height: 18px;
                    border-top-width: 1px;
                    border-top-style: solid;

                    &:first-child {
                        border-top-left-radius: 18px;
                        border-top: 1px solid rgba(202, 220, 253, .8) !important;
                    }

                    &.last-column {
                        border-top-right-radius: 18px;
                    }

                    .specail-box {
                        border-top-style: solid;
                        border-top-width: 2px;
                        height: 77px;
                    }

                    &.actived {
                        border-top: none;
                    }
                }

                &.column-3 {
                    border-right: 1px solid rgba(202, 220, 253, .8) !important;
                }

                &.last-line {
                    &:first-child {
                        border-bottom-left-radius: 18px;
                    }

                    &.last-column {
                        border-bottom-right-radius: 18px;
                    }

                    .specail-box {
                        height: 135%;
                        border-bottom-style: solid;
                        border-bottom-width: 2px;
                    }

                    &.actived {
                        border-bottom: none;
                    }
                }

                &.fisrt-column {
                    color: #1e1f24;
                    font-family: "PingFang SC";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 24px;
                }

                .false {
                    width: 20px;
                }

                .specail-box {
                    position: absolute;
                    z-index: 1;
                    width: 100%;
                    padding: 0 33px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-left-style: solid;
                    border-right-style: solid;
                    box-sizing: border-box;
                    border-left-width: 2px;
                    border-right-width: 2px;

                    &.first-box {
                        border-radius: 18px 18px 0 0;
                        bottom: 0;
                    }

                    &.last-box {
                        top: 0;
                        border-radius: 0 0 18px 18px;
                    }
                }
            }
        }
    }

    &.vip {
        .button {
            background: #fed9b9;
            color: #401611;
        }
    }
}
</style>
